<pui-page-header [title]="'Pomoc'">
    <pui-breadcrumbs>
        <a pui-breadcrumbs-item href="/">
            <pui-icon icon="home-line" />
        </a>
        <a pui-breadcrumbs-item href="/">Pomoc</a>
    </pui-breadcrumbs>
</pui-page-header>

<div class="page-container">
    <pui-tab-group [fullWidth]="true" [selected]="selectedTab" [vertical]="false" (valueChange)="onTabSelect($event)">
        <pui-tab [value]="'polish'">Polski</pui-tab>
        <pui-tab [value]="'english'">Angielski</pui-tab>
    </pui-tab-group>
    @if(selectedTab === 'polish'){
    <rqa-help-polish></rqa-help-polish>
    } @else{
    <rqa-help-english></rqa-help-english>
    }
</div>